import React, { useContext, useState, useEffect } from "react";
import {
  ChatBot,
  SearchInputArrowBtn,
  CommonGenerateBtn,
  CommonPromChat,
} from "../../common";
import { MyContext } from "../../context/ContextApi";
import { commonStr } from "../../utils/constants/commonStrings";
import { errorStr } from "../../utils/constants/errorStrings";
import { showToast } from "../../utils/helpers/helpers";
import uuid from "react-uuid";
import { omnilensGeneratePromptData } from "../../api/Postaction";

function OmniLens() {
  const {
    filterContent,
    newQuery,
    setCurretSession,
    currentSession,
    setSessionUpdate,
  } = useContext(MyContext);
  const [inputValue, setInputValue] = useState("");
  const [generating, setGenerating] = useState(false);
  const [data, setData] = useState([]);
  const [sessionName, setSessionName] = useState(uuid());

  const email = sessionStorage.getItem("email");

  useEffect(() => {
    setData([]);
    setSessionName(uuid());
    setCurretSession("");
  }, [newQuery]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      generatePrompt();
    }
  };

  const generatePrompt = async () => {
    if (inputValue === "") {
      showToast(errorStr.pleaseEnterQuery);
    } else {
      setInputValue("");
      setGenerating(true);
      let body = {
        user_question: inputValue,
        session_id: sessionName,
        email_id: email,
      };
      try {
        let res = await omnilensGeneratePromptData(body);
        if (res) {
          setData((prev) => [
            ...prev,
            {
              id: data.length + 1,
              user: inputValue,
              AI: res?.summary,
              // assist_agent: res?.assist_agent,
              // source: res?.source_docs ? res?.source_docs : "",
              // table: res?.table,
              // image: res?.base64_image,
            },
          ]);
          if (data.length === 0) {
            setSessionUpdate((current) => !current);
          }
          if (currentSession === "") {
            setCurretSession(sessionName);
          }
        }
        setGenerating(false);
      } catch (err) {
        console.log(err);
        setGenerating(false);
      }
    }
  };

  return (
    <div className="d-flex justify-content-between postionRelative">
      <div className="mainContent w-100">
        {data.length === 0 ? (
          <ChatBot userName={filterContent?.userName} />
        ) : (
          <div className="prompt">
            {data &&
              data?.length > 0 &&
              data.map((e, i) => (
                <CommonPromChat
                  indexValue={i}
                  key={i + 1}
                  user={e.user}
                  AI={e.AI}
                  assist_agent={e.assist_agent}
                  source={e?.source}
                  table={e?.table}
                  image={e?.image}
                />
              ))}
          </div>
        )}
        {generating && <CommonGenerateBtn title={commonStr.searching} />}
        <SearchInputArrowBtn
          value={inputValue}
          placeholder={commonStr.typeYourQuery}
          onKeyPress={handleKeyPress}
          onChange={(e) => setInputValue(e.target.value)}
          onClick={generatePrompt}
        />
      </div>
    </div>
  );
}

export default OmniLens;
